<template>
  <div id="HomePage" class="page-box">
    <div class="box">
      <Header :nav-list="navList" :active="4"/>
      <div class="placeholder"></div>
      <div class="container-fuild video-content">
        <div class="container">
          <p>直播页面功能</p>
          <div class="video-box  wow slideInUp">
            <video
              src="https://alggxcx.magicchair.net/uccn/live_video.mp4"
              controls
              style="width: 100%;"
            />
          </div>
        </div>
      </div>
      <div class="container">
        <div class=" wow slideInUp">
          <img
            src="https://alggxcx.magicchair.net/uccn/live_03.png"
            alt=""
            style="width: 100%;margin-bottom: 80px;margin-top: 120px;"
          />
        </div>
        <div class=" wow slideInUp">
          <img
            src="https://alggxcx.magicchair.net/uccn/live_04.png"
            alt=""
            style="width: 100%;"
          />
        </div>
      </div>
      <!-- 底部-->
      <Footer />
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "home",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      navList: [
        {
          id: 0,
          title: "首页",
          url: "/home",
        },
        {
          id: 1,
          title: "产品展示中心",
          url: "/home",
        },
        {
          id: 2,
          title: "在线商城",
          url: "/online_store",
        },
        {
          id: 3,
          title: "增值服务（付费）",
          url: "/home",
        },
        {
          id: 4,
          title: "直播",
          url: "/live_detail",
        },
        {
          id: 5,
          title: "联系我们",
          url: "/home",
        },
        {
          id: 6,
          title: "登录",
          url: "/home",
        },
        {
          id: 7,
          title: "注册",
          url: "/home",
        },
      ],
      payPop: false,
    };
  },
  mounted() {
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();
  },
  methods: {
    navJump(item) {
      if (item.url) {
        this.$router.push(item.url);
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "../assets/css/header.scss";
.page-box {
  background: #000;
}

::v-deep .box {
  /* 导航栏 */
  #header {
    position: absolute;
    top: 0px;
    background: #000;
    height: 80px;
    line-height: 80px;
    .header-nav-logo {
      margin-top: 20px;
    }
  }
}
.video-content {
  background: url(https://alggxcx.magicchair.net/uccn/live_02.png) no-repeat
    center center;
  background-size: 100% 100%;
  padding-top: 100px;
  p {
    font-weight: 600;
    font-size: 48px;
    color: #ffffff;
    margin-bottom: 80px;
    text-align: center;
  }
  .video-box {
    width: 100%;
    height: 100%;
    background: rgb(20, 24, 35);
    padding: 10px;
    border-radius: 20px 20px 20px 20px;
  }
}
</style>
